import { Link } from 'react-router-dom';
import { Facebook, Twitter, Linkedin, Youtube, Mail, MapPin, Phone, Instagram } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-stone-950 text-stone-400 border-t border-white/5" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="py-16 lg:py-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 lg:gap-16">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-3 mb-6 group">
              <img src="/assets/images/logo.png" alt="BHU Tourism Club" className="w-12 h-12 object-contain group-hover:scale-105 transition-transform" />
              <div>
                <span className="font-bold text-xl text-white uppercase tracking-tight">BHU Tourism</span>
                <span className="text-primary font-bold ml-1 uppercase">Club</span>
              </div>
            </Link>
            <p className="text-stone-400 mb-8 max-w-sm leading-relaxed">
              “Empowering students through tourism, heritage, innovation, and leadership.”
            </p>
            <div className="flex gap-4">
              {[
                { icon: Facebook, href: '#', label: 'Facebook' },
                { icon: Instagram, href: '#', label: 'Instagram' },
                { icon: Twitter, href: '#', label: 'Twitter' },
                { icon: Linkedin, href: '#', label: 'LinkedIn' }
              ].map((social) => (
                <a 
                  key={social.label}
                  href={social.href} 
                  className="w-10 h-10 bg-stone-900 border border-white/5 hover:bg-primary hover:text-white rounded-lg flex items-center justify-center transition-all" 
                  aria-label={social.label}
                >
                  <social.icon className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links Column */}
          <div>
            <h4 className="font-bold text-white mb-6 uppercase tracking-wider text-sm">Quick Links</h4>
            <ul className="space-y-4 text-sm">
              <li><Link to="/about" className="hover:text-primary transition-colors">About Us</Link></li>
              <li><Link to="/gallery" className="hover:text-primary transition-colors">Media Gallery</Link></li>
              <li><Link to="/blog" className="hover:text-primary transition-colors">Tourism Blog</Link></li>
              <li><Link to="/join" className="hover:text-primary transition-colors">Join the Club</Link></li>
              <li><Link to="/contact" className="hover:text-primary transition-colors">Contact Us</Link></li>
            </ul>
          </div>

          {/* Programs Column */}
          <div>
            <h4 className="font-bold text-white mb-6 uppercase tracking-wider text-sm">Programs</h4>
            <ul className="space-y-4 text-sm">
              <li><Link to="/educational-tourism" className="hover:text-primary transition-colors">Educational Tours</Link></li>
              <li><Link to="/heritage-tourism" className="hover:text-primary transition-colors">Heritage Walks</Link></li>
              <li><Link to="/internships-placements" className="hover:text-primary transition-colors">Internships</Link></li>
              <li><Link to="/events" className="hover:text-primary transition-colors">Events & Quizzes</Link></li>
              <li><Link to="/innovation" className="hover:text-primary transition-colors">Startup Hub</Link></li>
            </ul>
          </div>

          {/* Help Desk Column */}
          <div>
            <h4 className="font-bold text-white mb-6 uppercase tracking-wider text-sm">Support</h4>
            <ul className="space-y-4 text-sm">
              <li><Link to="/contact" className="hover:text-primary transition-colors">Student Help Desk</Link></li>
              <li><Link to="/collaborate" className="hover:text-primary transition-colors">Collaboration Inquiry</Link></li>
              <li><Link to="/rgsc" className="hover:text-primary transition-colors">RGSC Development</Link></li>
              <li><Link to="/privacy" className="hover:text-primary transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-primary transition-colors">Terms of Service</Link></li>
            </ul>
          </div>
        </div>

        {/* Contact Bar */}
        <div className="py-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="flex flex-wrap justify-center gap-8 text-sm">
            <a href="mailto:tourismclub@bhu.ac.in" className="flex items-center gap-3 hover:text-primary transition-colors">
              <div className="w-8 h-8 rounded-full bg-stone-900 flex items-center justify-center">
                <Mail className="w-4 h-4 text-primary" />
              </div>
              tourismclub@bhu.ac.in
            </a>
            <span className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-full bg-stone-900 flex items-center justify-center">
                <MapPin className="w-4 h-4 text-primary" />
              </div>
              Banaras Hindu University, Varanasi
            </span>
          </div>
        </div>

        {/* Copyright */}
        <div className="py-8 border-t border-white/5 text-center text-xs text-stone-500">
          <p>© {currentYear} BHU Tourism Club. Official Website of Banaras Hindu University. All rights reserved.</p>
          <p className="mt-2 text-[10px] opacity-30 hover:opacity-100 transition-opacity">
            Developed by <a href="https://www.ranti.dev/" className="hover:text-primary transition-colors">Rantideb</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
